import SimpleMarkdown from 'components/SimpleMarkdown';
import { Box } from 'grommet';
import usePageTitle from 'hooks/usePageTitle';
import { asset$ } from 'modules/asset/asset$';
import React from 'react';
import { connect } from 'rxbeach/react';
import { combineLatest, map } from 'rxjs';
import styled from 'styled-components';
import { Asset } from 'types';
import { compare } from 'utils/sortUtils';

export const StyledBox = styled(Box)`
  width: 100%;
  color: #333333;
  text-align: center;
`;

const viewModel$ = combineLatest([asset$]).pipe(
  map(([{ byId }]) => ({
    assets: Object.values(byId)
      .filter((e) => e.type === 'leie')
      .sort(compare('order')),
  }))
);

const backgroundColors = ['white', '#b8e2f2aa', '#f0ffffaa'];

const RentUs = ({ assets }: { assets: Asset[] }) => {
  usePageTitle('Leie Lokaler');
  return (
    <>
      {assets.map((asset, i) => (
        <StyledBox
          pad="small"
          key={asset.id}
          background={backgroundColors[i] || 'white'}
        >
          <SimpleMarkdown key={asset.id} asset={asset} />
        </StyledBox>
      ))}
    </>
  );
};

export default connect(RentUs, viewModel$);
